import React from 'react'
import ReactDOM from 'react-dom/client'
// libs
import { HelmetProvider } from 'react-helmet-async'
// components
import App from './App'
// css
import 'nprogress/nprogress.css'
import 'cropperjs/dist/cropper.css'
import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-sortable-tree/style.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
)
